import { connect } from 'react-redux';
import ThemeSwitch from '../components/ThemeSwitch'
import { toggleTheme } from '../store/display';

export default connect(
  ({display}) => ({isLight: display.theme === "light" ? true : false}),
  { toggleTheme }
)(ThemeSwitch);
